"use client"

interface PricingSectionHeaderProps {
    publicMode?: boolean
    credits?: number
}

export function PricingSectionHeader({ publicMode, credits }: PricingSectionHeaderProps) {
    return (
        publicMode ? <div className="relative padding-x-[20px]">
            <h2 className='text-black font-extrabold text-3xl sm:text-4xl md:text-[55px] leading-none tracking-normal text-center md:text-left'>
                <span className="block">Start for free</span>
                <strong className="block font-extrabold">Upgrade to scale</strong>
            </h2>
        </div> : <div>
            <h2 className="text-black font-bold text-3xl tracking-normal text-center">
                Choose Your Plan
            </h2>
            <p className="mt-2 text-black font-medium text-base tracking-normal text-center">
                {credits != null ? `Get ${credits.toLocaleString()} credits` : 'Get more credits'} and unlock more insights to reach your goals.
            </p>
        </div>
    )
}
